import React, { useCallback, useState } from "react";
import useTranslation from "../util/useTranslate";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { CheckCircleFill } from "react-bootstrap-icons";
import ParallaxBackground from "./ParallaxBackground";
import PlayerIcon from "./PlayerIcon";
import useSupabaseRoomSubscription from "util/useSupabaseRoomSubscription";
import { togglePlayerReady } from "../util/supabase";

const Discussion = ({ gameSettings, currentPlayer }) => {
  const translate = useTranslation();
  const [chatMessages, setChatMessages] = useState([]);
  const [currentChatMessage, setCurrentChatMessage] = useState("");
  const { gameId } = useParams();

  const { broadcastEvent } = useSupabaseRoomSubscription({
    subscriptionId: currentPlayer.id,
    channelName: `GAME_${gameId}_${currentPlayer.team}`,
    onEvent: ({ event, payload }) => {
      if (event === "chatMessage") {
        setChatMessages([payload, ...chatMessages]);
      }
    },
  });

  const handlePlayerReadyToggle = (e) => {
    togglePlayerReady(gameId, currentPlayer.id);
  };

  const sendChatMessage = (e) => {
    e.preventDefault();
    broadcastEvent("chatMessage", {
      id: currentPlayer.id,
      name: currentPlayer.name,
      message: currentChatMessage,
    });
    setCurrentChatMessage("");
  };

  const getPlayerIndex = useCallback(
    (id) => gameSettings.players.findIndex((item) => item.id === id),
    [gameSettings.players]
  );

  return (
    <>
      <Container className="vh-100 mt-4">
        <Card className="d-flex gap-4 p-2 flex-row align-items-center">
          <h3>{translate("playersReady")}</h3>{" "}
          {gameSettings.players.map((player, index) => (
            <PlayerIcon
              key={player.id}
              playerIndex={index}
              active={player.isReady}
            />
          ))}
        </Card>
        <Card className="h-75 mt-4" style={{ overflowY: "auto" }}>
          <Card.Body className="d-flex flex-column-reverse gap-2">
            {chatMessages.map(({ id, name, message }, index) => (
              <div className="d-flex align-items-center gap-2" key={index}>
                <PlayerIcon inline playerIndex={getPlayerIndex(id)} active />
                <b>{name}</b>: {message}
              </div>
            ))}
          </Card.Body>
        </Card>
        <form onSubmit={sendChatMessage}>
          <Row className="mt-2">
            <Col md={7} className="mb-2">
              {" "}
              <Form.Control
                type="text"
                value={currentChatMessage}
                onChange={(e) => setCurrentChatMessage(e.target.value)}
                placeholder={translate("writeMessage")}
              />
            </Col>
            <Col md={2}>
              <Button type="submit" disabled={!currentChatMessage} className="w-100 mb-2" variant="primary">
                {translate("send")}
              </Button>
            </Col>
            <Col md={3}>
              <Button
                className="w-100 mb-2"
                variant={currentPlayer.isReady ? "success" : "primary"}
                onClick={handlePlayerReadyToggle}
              >
                {translate("ready")} <CheckCircleFill />
              </Button>
            </Col>
          </Row>
        </form>
      </Container>
      <ParallaxBackground
        src={"/backgrounds/juha.png"}
        position={"bottom left"}
        size={"45vh"}
      />
      <ParallaxBackground
        src={"/backgrounds/kapula.png"}
        position={"bottom right"}
        size={"20vh"}
      />
    </>
  );
};

export default Discussion;
